module.exports = __webpack_public_path__ + "img/icon_wc_02.12475d22.png";